var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.4382C12.5188 14.4382 13.75 13.207 13.75 11.6882C13.75 10.1694 12.5188 8.93823 11 8.93823C9.48122 8.93823 8.25 10.1694 8.25 11.6882C8.25 13.207 9.48122 14.4382 11 14.4382Z",
    stroke: "#0A9281",
    strokeWidth: 1.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83313 12.4949V10.8815C1.83313 9.92821 2.6123 9.13988 3.5748 9.13988C5.23396 9.13988 5.9123 7.96655 5.07813 6.52738C4.60146 5.70238 4.88563 4.62988 5.7198 4.15321L7.30563 3.24571C8.0298 2.81488 8.9648 3.07155 9.39563 3.79571L9.49646 3.96988C10.3215 5.40905 11.6781 5.40905 12.5123 3.96988L12.6131 3.79571C13.044 3.07155 13.979 2.81488 14.7031 3.24571L16.289 4.15321C17.1231 4.62988 17.4073 5.70238 16.9306 6.52738C16.0965 7.96655 16.7748 9.13988 18.434 9.13988C19.3873 9.13988 20.1756 9.91905 20.1756 10.8815V12.4949C20.1756 13.4482 19.3965 14.2365 18.434 14.2365C16.7748 14.2365 16.0965 15.4099 16.9306 16.849C17.4073 17.6832 17.1231 18.7465 16.289 19.2232L14.7031 20.1307C13.979 20.5615 13.044 20.3049 12.6131 19.5807L12.5123 19.4065C11.6873 17.9674 10.3306 17.9674 9.49646 19.4065L9.39563 19.5807C8.9648 20.3049 8.0298 20.5615 7.30563 20.1307L5.7198 19.2232C4.88563 18.7465 4.60146 17.674 5.07813 16.849C5.9123 15.4099 5.23396 14.2365 3.5748 14.2365C2.6123 14.2365 1.83313 13.4482 1.83313 12.4949Z",
    stroke: "#0A9281",
    strokeWidth: 1.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.29b85b2f56d17816b1ccfb0dac430cb5.svg";
export { ForwardRef as ReactComponent };